// Browser persistence helpers for auth state.
// These are the ONLY places that touch localStorage — swap for cookies, sessionStorage,
// or an encrypted store in one edit if your compliance review requires it.

const ACCESS_KEY = 'wantok.access'
const REFRESH_KEY = 'wantok.refresh'
const USER_KEY = 'wantok.user'

export const getAccessToken = () => localStorage.getItem(ACCESS_KEY)
export const getRefreshToken = () => localStorage.getItem(REFRESH_KEY)

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const setAccessToken = (t) => { if (t) localStorage.setItem(ACCESS_KEY, t) }
export const setRefreshToken = (t) => { if (t) localStorage.setItem(REFRESH_KEY, t) }
export const setStoredUser = (u) => { if (u) localStorage.setItem(USER_KEY, JSON.stringify(u)) }

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_KEY)
  localStorage.removeItem(REFRESH_KEY)
  localStorage.removeItem(USER_KEY)
}
